import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { NutritionFactsContentFragment } from '@/models';

@Component({
  name: 'CmgNutritionCalculatorMealBuilderMobileGraphFooter',
})
export default class CmgNutritionCalculatorMealBuilderMobileGraphFooter extends Vue {
  windowSize = 0;
  graphFooterTop = 0;
  nutritionFacts: NutritionFactsContentFragment | null = null;

  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get currentNutrition() {
    return this.$store.state.mealBuilderV2.nutrition;
  }

  get kebabIconUrl(): string {
    return this.$appStore.state.cms.images.icons.kebabMenu.default;
  }

  get footerIsSticky(): boolean {
    // Disabling the sticky nutrition footer for now
    // return (this.windowSize <= this.graphFooterTop) ? true : false;
    return false;
  }

  get fullFactsLabel() {
    return this.nutritionFacts?.label;
  }

  get fullFactsPath() {
    return this.nutritionFacts?.path;
  }

  getEnergyLabelByCountry(){
    if(this.countryCode === 'GB') {
      return 'kcal';
    }
    return 'Calories'
  }
 
  onScroll() {
    this.graphFooterTop = (this.$refs.graphFooter as HTMLElement).getBoundingClientRect().top;
  }

  onResize() {
    this.windowSize = window.innerHeight;
  }
  
  created() {
    this.$services.config.setNutritionFacts();
  }

  async mounted() {
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);

    this.windowSize = window.innerHeight;
    this.graphFooterTop = this.windowSize;

    let nutritionFacts = this.$services.config.getNutritionFacts();
    if (nutritionFacts) {
      this.nutritionFacts = nutritionFacts;
    }
    else {
      await this.$services.config.setNutritionFacts();
      this.nutritionFacts = this.$services.config.getNutritionFacts()!;
    }
  }
  
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  currentNutritionValue(key: string) {
    return Math.round(this.currentNutrition[key]);
  }

  onClickFullDetails() {
    this.$services.ui.setModalVisibility('mobileNutritionDetails', true);
  }
}
